import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from 'app/services/apis.service';
import { LoadingService } from 'app/services/loading.service';

@Component({
  selector: 'app-upload-refund-receipt',
  templateUrl: './upload-refund-receipt.component.html',
  styleUrls: ['./upload-refund-receipt.component.scss']
})
export class UploadRefundReceiptComponent implements OnInit {

    userId: string | null = null;
  payoutAccountId: string | null = null;
selectedStatus: string = "";  // default


  /**
   *
   * Variables
   *
   */
   files: File[] = [];
  imagePreview: string | ArrayBuffer | null = null;
  selectedOption: any;
  mediaName: any;
  mediaUrl: any;
  mediaForm: FormGroup;
    public totalPaid : any

  formData = {
    amount: null,
    note: '',
    transferRef: ''
  };

  currency : any


/**
 *
 * End Of variables
 *
 */
  
  constructor(
    private apiservice : ApisService , 
    private loading : LoadingService ,
    private fb : FormBuilder,
    private route: ActivatedRoute,
      private router: Router

  ) { }

    ngOnInit(): void {
          this.totalPaid = history.state.amount
          this.currency = history.state.currency
    console.log("totalPaid" , this.totalPaid);
    console.log("currency" , this.currency);
this.userId = this.route.snapshot.paramMap.get('id');

    this.payoutAccountId = this.route.snapshot.paramMap.get('payoutAccountId');

    console.log("User ID:", this.userId);
    console.log("Payout Account ID:", this.payoutAccountId);

    this.mediaForm = this.fb.group({
      files: this.fb.array([
        this.fb.group({
          name: ['', [Validators.required, Validators.minLength(3)]],
        })
      ])
    });
  }

/*----------  Upload File Select ----------*/
onSelect(event: any) {
  this.files = [...event.addedFiles];

  if (this.files.length > 0) {
    const filesArray = this.mediaForm.get('files') as FormArray;
    const fileGroup = filesArray.at(0) as FormGroup;

    // Sanitize file name (replace spaces with underscores)
    const originalFile = this.files[0];
const sanitizedValue = this.files[0].name.replace(/[\s-]+/g, '')
console.log("Safe File Name:", sanitizedValue);  
    // Create a new File with safe name
    const sanitizedFile = new File([originalFile], sanitizedValue, { type: originalFile.type });

    // Replace in files array
    this.files[0] = sanitizedFile;

    // Patch to form
    fileGroup.patchValue({ name: sanitizedFile });

    // Preview
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result;
    };
    reader.readAsDataURL(sanitizedFile);

    console.log("Sanitized File:", sanitizedFile);
    console.log("Form Value:", this.mediaForm.value);
  }
}



  /*----------  Request Presigned URL ----------*/
  presignedUrl() {
    this.apiservice.presignedUrl(this.mediaForm.value).subscribe({
      next: (res) => {
        console.log("Presigned response", res);
        this.mediaUrl = res.data?.[0].url;
        this.mediaName = res.data?.[0].name;
        this.uploadMedia();
      },
      error: (error) => {
        console.log("Presigned error", error);
      },
    });
  }

  /*----------  Upload Media File ----------*/
  uploadMedia() {
    this.apiservice.MediaUpload(this.mediaUrl, this.files[0]).subscribe({
      next: (res) => {
        console.log("Media uploaded", res);
        this.submitTransaction(); // ✅ only after successful upload
      },
      error: (error) => {
        console.log("Upload error", error);
      },
    });
  }

  /*----------  Final API Call ----------*/
/*----------  Final API Call ----------*/
/*----------  Final API Call ----------*/
submitTransaction() {
  const payload: any = {
    providerId: this.userId ? Number(this.userId) : 0,
    payoutAccountId: this.payoutAccountId ? Number(this.payoutAccountId) : 0,
    amountCents: Number(this.formData.amount) * 100,
    currency: this.currency,
    note: this.formData.note || "",
    status: this.selectedStatus || "",
    transferRef: this.formData.transferRef || "",
    proofImageName: this.files.length > 0 ? this.files[0].name : null
  };

  console.log("Final JSON Payload:", payload);

  this.apiservice.createTransaction(payload).subscribe({
    next: (res) => {
      console.log("✅ Transaction created successfully", res);
      // Navigate after success
      this.router.navigate(['/accounting/finance']);
    },
    error: (error) => console.error("❌ Transaction error", error)
  });
}


}